import { __makeTemplateObject } from "tslib";
import { css } from '../../../../foundation';
import { RcStepButtonClasses } from '../utils';
export var StepButtonStyle = function () {
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    .", " {\n      z-index: 1;\n    }\n  "], ["\n    .", " {\n      z-index: 1;\n    }\n  "])), RcStepButtonClasses.touchRipple);
};
var templateObject_1;
